<!--<div id="desktop">-->
<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12">
      <br /><br />
      <h4 style="font-weight:bold; text-decoration:underline; text-align:center">Agree or Disagree</h4>
      <br/>
      You may be a member of the Settlement Class in this action for a new Settlement reached with Tyson Foods, Inc. and
      Tyson Fresh Meats, Inc. (collectively, “Tyson”). The Settlement Class, subject to certain exclusions, is defined as:<br /><br />

      All persons and entities who directly purchased Beef for use or delivery in the United States, whether fresh or frozen,
      made from one of the following primals: chuck, loin, rib, or round from Defendants, or their respective subsidiaries or
      affiliates, from January 1, 2015, to February 29, 2020. For this lawsuit, beef excludes any product that is marketed as
      organic, grass-fed, kosher, halal, certified humane, Wagyu, “American-Style Kobe Beef,” and any product that is cooked,
      marinated, seasoned, flavored, or breaded.<br /><br />

      After the Court approves the Settlement and any appeals are resolved, a claims process will commence to distribute the
      Net Settlement Funds to eligible Settlement Class Members. In accordance with the terms of the Settlement, the Settlement
      Proceeds, minus Court-approved attorneys’ fees, any class representative service awards, and notice and claims administration
      costs (the “Net Settlement Fund”), will be distributed to Settlement Class Members on a pro rata (or proportional) basis
      based on the amount of Beef purchases by each participating Settlement Class Member compared to the combined Beef purchases
      of all participating Settlement Class Members.<br /><br />

      <h4 style="font-weight:bold">Instructions</h4>

      <b>
        If you already filed an approved claim in the previous settlement with JBS, you will automatically be eligible to receive
      a payment and do not need to submit another claim. However, due to changes between the settlement class definition from the
      JBS settlement, your pre-populated claim amount will differ from the JBS settlement. If you agree with the new pre-populated
      claim amount below, you may accept the purchase amounts online or by mail, or you may do nothing and your claim will be
      processed using the pre-populated amount.
      </b><br />
      2.	If you agree with the purchase information, please click on Agree<br />
      3.	If you do not agree with the purchase information, please click on Disagree<br /><br />


    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <b><u>Unique ID:</u></b>&nbsp;&nbsp;&nbsp;{{au.uniqueId}}<br /><br />

      <table class="table table-bordered table-striped" #listofInformation>
        <thead>
          <tr>
            <th>DEFENDANT</th>
            <th>
              2015
            </th>
            <th>
              2016
            </th>
            <th>
              2017
            </th>
            <th>
              2018
            </th>
            <th>
              2019
            </th>
            <th>
              2020
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="font-weight:bold">Cargill</td>

            <td>${{au.cargill2015}}</td>
            <td>${{au.cargill2016}}</td>
            <td>${{au.cargill2017}}</td>
            <td>${{au.cargill2018}}</td>
            <td>${{au.cargill2019}}</td>
            <td>${{au.cargill2020}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">JBS</td>

            <td>${{au.jbs2015}}</td>
            <td>${{au.jbs2016}}</td>
            <td>${{au.jbs2017}}</td>
            <td>${{au.jbs2018}}</td>
            <td>${{au.jbs2019}}</td>
            <td>${{au.jbs2020}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">National Beef</td>
            <td>${{au.nationalBeef2015}}</td>
            <td>${{au.nationalBeef2016}}</td>
            <td>${{au.nationalBeef2017}}</td>
            <td>${{au.nationalBeef2018}}</td>
            <td>${{au.nationalBeef2019}}</td>
            <td>${{au.nationalBeef2020}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Tyson</td>
            <td>${{au.tyson2015}}</td>
            <td>${{au.tyson2016}}</td>
            <td>${{au.tyson2017}}</td>
            <td>${{au.tyson2018}}</td>
            <td>${{au.tyson2019}}</td>
            <td>${{au.tyson2020}}</td>
          </tr>

        </tbody>
      </table>
      <br /><br />
    </div>
    <div class="col-md-1"></div>
  </div>
  <div class="row">
    <div class="col-md-12" style="text-align:center; font-size:1.3em">
      <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{au.purchaseNetTotal}}<br /><br />

    </div>
    </div>
  <div class="row">
    <div class="col-md-2">
    </div>
    <div class="col-md-2">
      <a style="font-weight: bold; font-size: 1.3em" href="/agree">Agree</a>
    </div>
    <div class="col-md-4">
    </div>
    <div class="col-md-4">
      <a style="font-weight: bold; font-size: 1.3em" href="/audit-request">Disagree</a>
    </div>
  </div>
  <br/><br/>
  </div>
    <!--</div>-->
    <!--<div id="mobile">
      <div class="container" style="border:1px solid #bebaba">
        <div class="row indentContent">
          <div class="col-md-12">
            <h2 class="red" id="FontTwoMobile">Contact Information</h2>
            <div>
              <p class="text-center" style="font-weight:bold;margin-top:3%">You may write to the Claims Administrator at:</p>
              <div class="row">
                <div class="col-md-12 text-center">
                  Broilers CIIPP Settlement<br />
                  Claims Administrator<br />
                  c/o A.B. Data, Ltd.<br />
                  P.O. Box 173122<br />
                  Milwaukee, WI 53217<br />
                  E-mail:  <a href="mailto:info@chickencommercialsettlement.com">info@chickencommercialsettlement.com</a><br />
                  Toll-Free Number: 1-800-983-6533<br />
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
        <br /><br />
      </div>
      <app-footer></app-footer>
    </div>-->
